import { render, staticRenderFns } from "./AdminFee.vue?vue&type=template&id=3f2164e4&scoped=true&lang=pug&"
import script from "./AdminFee.vue?vue&type=script&lang=js&"
export * from "./AdminFee.vue?vue&type=script&lang=js&"
import style0 from "./AdminFee.vue?vue&type=style&index=0&id=3f2164e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2164e4",
  null
  
)

export default component.exports